import { createSlice } from "@reduxjs/toolkit";
import { fontSettings as configFontSettings } from "config";


const initialState = {
    currentMeeting: {},

    currentMeetingUsers: [],
    currentMeetingParticipants: [],

    currentAgenda: [],
    currentAgendaList: [],

    currentMeetingVoteList: null,
    currentMeetingReviewList: null,

    pageType: {},

    init: true,

    fontSettings: configFontSettings.find(font => font.id === "medium") || {},

    agendaSnackbar: {
        open: false,
        message: '',
        severity: 'success',
        openedAt: 0
    }
};



export const meetingSlice = createSlice({
    name: 'meeting',
    initialState,
    reducers: {
        setCurrentMeeting: (state, action) => {
            state.currentMeeting = action.payload
        },
        setCurrentMeetingUsers: (state, action) => {
            state.currentMeetingUsers = action.payload
        },
        setCurrentMeetingParticipants: (state, action) => {
            state.currentMeetingParticipants = action.payload
        },

        setCurrentAgenda: (state, action) => {
            state.currentAgenda = action.payload
        },
        setCurrentAgendaList: (state, action) => {
            state.currentAgendaList = action.payload
        },
        setCurrentMeetingVoteList: (state, action) => {
            state.currentMeetingVoteList = action.payload
        },
        setCurrentMeetingReviewList: (state, action) => {
            state.currentMeetingReviewList = action.payload
        },

        setPageType: (state, action) => {
            state.pageType = action.payload || [];
        },

        setFontSettings: (state, action) => {
            state.fontSettings = action.payload
        },

        showAgendaSnackbar: (state, action) => {
            state.agendaSnackbar = {
                open: true,
                message: action.payload.message,
                severity: action.payload.severity || 'success',
                openedAt: Date.now()
            };
        },
        hideAgendaSnackbar: (state) => {
            state.agendaSnackbar.open = false;
        }
    },
});



export const { setCurrentMeeting, setCurrentAgenda, setCurrentAgendaList,

    pageType, setPageType,
    currentMeetingUsers,
    setCurrentMeetingUsers,

    currentMeetingReviewList,
    setCurrentMeetingReviewList,

    currentMeetingVoteList,
    setCurrentMeetingVoteList,

    currentMeetingParticipants,
    setCurrentMeetingParticipants,

    fontSettings,
    setFontSettings,

    showAgendaSnackbar,
    hideAgendaSnackbar

} = meetingSlice.actions;



export default meetingSlice.reducer;
